import { AdjustableHeight } from '../helpers/AdjustableHeight';
import Splide from '@splidejs/splide';

const selectors = {
  carousel: '[data-hero-carousel]',
};

export default class DynamicHero {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.slideCount = this.data.slideCount;
    this.carouselEl = this.el.querySelector(selectors.carousel);
    this.splide = null;

    this._init();
  }

  _init() {
    if (!this.carouselEl || this.slideCount <= 1) {
      return;
    }

    this.splide = new Splide(this.carouselEl, {
      perPage: 1,
      perMove: 1,
      gap: 0,
      type: 'loop',
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      arrows: false,
      pagination: true,
      adjustableHeight: {
        whileSliding: true,
        speed: '0.4s',
      },
    });

    this.splide.mount({ AdjustableHeight });
  }

  onSectionUnload() {
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
